import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/img2.PNG";
import projImg2 from "../assets/img/img4.PNG";
import projImg3 from "../assets/img/img5.PNG";
import projImg4 from "../assets/img/img22.PNG";
import projImg5 from "../assets/img/img23.PNG";
import projImg6 from "../assets/img/net.PNG";
import colorSharp2 from "../assets/img/color-sharp2.png";
import netg from "../assets/img/netg.PNG"
import blog from "../assets/img/blog.PNG"
import yy from "../assets/img/yy.PNG"
import exp from "../assets/img/exp.PNG"
import hulu from "../assets/img/hulu.PNG"
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Project = () => {

  const projects = [
    {
      title: "Linkdin Clone",
      description: "Build Using React,Redux & Firebase",
      imgUrl: projImg1,
      github:"https://github.com/AsmaIbrahimButt/Linkdineclone.git",
      demo:"https://linkdin-clone-858c7.web.app/"
    },
    {
      title: "Gmail Clone",
      description: "Build Using React,Redux & Firebase",
      imgUrl: projImg2,
      github:"https://github.com/AsmaIbrahimButt/Gmail-Clone.git",
      demo:"https://clone-e442b.web.app/"
    },
    {
      title: "Slack Clone",
      description: "Build Using React,Redux & Firebase",
      imgUrl: projImg3,
      github:"https://github.com/AsmaIbrahimButt/Slack-Clone.git",
      demo:"https://slack-clone-a73e7.web.app/room/KOyLWWFERCGRTQvD20lO"
    },
    {
      title: "Portfolio Website",
      description: "React,BootstrapCss,Css",
      imgUrl: projImg4,
      github:"https://github.com/AsmaIbrahimButt/PersonalPortfolio.git",
      demo:"https://cool-macaron-a968d4.netlify.app/"
    },
    {
      title: "Fetching Github User React App",
      description: "Build using ReactHooks",
      github:"https://github.com/AsmaIbrahimButt/GitHub-User.git",
      demo:"https://cool-macaron-a968d4.netlify.app/",
      imgUrl: projImg5,
    },
    {
      title: "Netflix Clone",
      description: "Build using React ,Redux,Tmdb Database",
      imgUrl: netg,
      github:"https://github.com/AsmaIbrahimButt/NetflixClone.git",
      demo:"https://frolicking-kelpie-b6c3a9.netlify.app/"
    },
   
  
  ];
  const projectnext = [

    {
      title: "Hulu-Clone",
      description: "Build using Nextjs",
      imgUrl: hulu,
      github:"https://github.com/AsmaIbrahimButt/huluclone.git",
      demo:"#"
    },
  ];
  const projectmern = [

    {
      title: "NodeChat",
      description: "Build using Nodejs",
      imgUrl: yy,
      github:"https://github.com/AsmaIbrahimButt/Nodechat.git",
      demo:"#"
    },
    {
      title: "Expense tracker",
      description: "Build using React ,Node,Express .Mongodb Database",
      imgUrl: exp,
      github:"https://github.com/AsmaIbrahimButt/ExpenseTraker.git",
      demo:"#"
    },
    {
      title: "Blog Markdown",
      description: "Build using React ,Node,Express .Mongodb Database",
      imgUrl: blog,
      github:"https://github.com/AsmaIbrahimButt/BlogMarkdown.git",
      demo:"#"
    },
  ]

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p> My Personal Projects using react,redux firebase,nodejs.express and mongodb</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">React & Firebase</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Mern Stack</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Nexjs</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
  
                            )
                          })
                        }
                        
                     
                      </Row>
                     
                    </Tab.Pane>
                  
                    <Tab.Pane eventKey="second">
                    
                    <Row>
                        {
                          projectmern.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
  
                            )
                          })
                        }
                        
                     
                      </Row>
                 
                </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    <Row>
                    {
                      projectnext.map((project, index) => {
                        return (
                          <ProjectCard
                            key={index}
                            {...project}
                            />

                        )
                      })
                    }
                    
                 
                  </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    
    </section>
  )
}